<app-date-range-setting
        [data]="data"
        [dateLimit]="dateLimit"
        (payload)="emittedValuesHandler($event)"
></app-date-range-setting>
